import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  LayoutDashboard, Rss, Inbox, Layers, FileText, Key,
  Users, Settings, Activity, Cpu, X, Newspaper
} from 'lucide-react';

const navItems = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { to: '/sources', icon: Rss, label: 'Sources' },
  { to: '/feed', icon: Inbox, label: 'Incoming Feed' },
  { to: '/clusters', icon: Layers, label: 'Story Clusters' },
  { to: '/articles', icon: FileText, label: 'Generated Articles' },
  { divider: true },
  { to: '/api-keys', icon: Key, label: 'API Keys', role: 'admin' },
  { to: '/users', icon: Users, label: 'Users & Roles', role: 'admin' },
  { to: '/jobs', icon: Cpu, label: 'Jobs Queue', role: 'admin' },
  { to: '/activity', icon: Activity, label: 'Activity Log', role: 'admin' },
  { to: '/settings', icon: Settings, label: 'Settings', role: 'admin' },
];

export const Sidebar = ({ isOpen, onClose }) => {
  const { isAdmin } = useAuth();

  const filteredItems = navItems.filter(item => {
    if (item.divider) return true;
    if (item.role === 'admin' && !isAdmin) return false;
    return true;
  });

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div className="fixed inset-0 bg-black/30 z-40 lg:hidden" onClick={onClose} />
      )}

      <aside className={`fixed top-0 left-0 z-40 h-screen w-60 bg-white border-r border-gray-200 flex flex-col transition-transform duration-200 lg:translate-x-0 ${isOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        {/* Logo */}
        <div className="flex items-center gap-3 px-5 h-14 border-b border-gray-200 flex-shrink-0">
          <div className="h-8 w-8 bg-primary-500 rounded-lg flex items-center justify-center flex-shrink-0">
            <Newspaper className="h-4 w-4 text-white" />
          </div>
          <div className="min-w-0">
            <div className="text-sm font-bold text-gray-900 truncate">Newsdesk</div>
            <div className="text-[10px] text-gray-400 -mt-0.5">by Omniapps</div>
          </div>
          <button onClick={onClose} className="ml-auto p-1 rounded hover:bg-gray-100 lg:hidden">
            <X className="h-4 w-4 text-gray-400" />
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto py-3 px-3 scrollbar-thin">
          {filteredItems.map((item, i) => {
            if (item.divider) {
              return <div key={i} className="my-2 border-t border-gray-100" />;
            }
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                onClick={onClose}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors mb-0.5 ${
                    isActive
                      ? 'bg-primary-50 text-primary-700'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                  }`
                }
              >
                <Icon className="h-4 w-4 flex-shrink-0" />
                <span className="truncate">{item.label}</span>
              </NavLink>
            );
          })}
        </nav>

        {/* Footer */}
        <div className="p-3 border-t border-gray-100">
          <div className="px-3 py-2 text-xs text-gray-400">
            Omniapps Newsdesk v1.0
          </div>
        </div>
      </aside>
    </>
  );
};
